
(function(template){
    define('vue!optionalClassProgram/components/helperComponents/loaderComponent',['Vue'],function(Vue){
        return {
            template:template,
            props: ['showLoader']
        }
    })
})('<div class="fetching-loader " v-show="showLoader"> <div></div> <p> {{ localization.spaBooking.packageBooking.optionalClass.bookingIndication}}</p> </div>');
